import { gsapScramble } from "../utils/scrambleText";

export default function initKpiTrackerAnimation() {
  const rows = document.querySelectorAll('.kpi-tracker-animation');
  if (!rows.length) return;

  // Stagger row starts so they don't all fire simultaneously
  rows.forEach((row) => {
    setTimeout(() => runRow(row), randomInt(0, 1000));
  });
}

// ─── Helpers ────────────────────────────────────────────────────────────────

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function pad(n, len) {
  return String(n).padStart(len, '0');
}

// ─── Reset ──────────────────────────────────────────────────────────────────

function resetRow(row) {
  // Hide all graphs
  row.querySelectorAll('.kpi-graph__svg').forEach(svg => {
    svg.style.transition = 'none';
    svg.style.clipPath = 'inset(0 100% 0 0)';
    svg.style.display = 'none';
  });

  // Reset all loader lines
  row.querySelectorAll('.kpi-loader__line').forEach(line => {
    line.classList.remove('kpi-loader__line--loaded');
  });

  // Reset result — show only pending
  row.querySelector('.kpi-result__icon--check').style.display = 'none';
  row.querySelector('.kpi-result__icon--error').style.display = 'none';
  row.querySelector('.kpi-result__icon--pending').style.display = 'block';
}

// ─── Main run loop ──────────────────────────────────────────────────────────
function runRow(row) {
  const duration = randomInt(2_000, 6_000); // total animation duration ms
  const isSuccess = Math.random() < 0.85;   // 85% success, 15% error

  resetRow(row);

  // 1. KPI label — random 3-digit number, scramble in
  const kpiNum = pad(randomInt(100, 999), 3);
  const labelSpan = row.querySelector('.kpi-id');
  labelSpan.textContent = `#KPI${kpiNum}`;
  labelSpan.dataset.animateFrom = `#ZB${pad(randomInt(100, 999), 3)}`;
  gsapScramble(labelSpan);

  // 2. Pick & reveal a random graph via clip-path left → right
  const graphs = Array.from(row.querySelectorAll('.kpi-graph__svg'));
  const activeGraph = graphs[randomInt(0, graphs.length - 1)];
  activeGraph.style.display = 'block';

  // Double rAF ensures the display:block is painted before transition starts
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      activeGraph.style.transition = `clip-path ${duration}ms ease-in-out`;
      activeGraph.style.clipPath = 'inset(0 0% 0 0)';
    });
  });

  // 3. Progressively load each loader line over the duration
  const lines = Array.from(row.querySelectorAll('.kpi-loader__line'));
  const lineInterval = duration / lines.length;

  lines.forEach((line, i) => {
    setTimeout(() => {
      line.classList.add('kpi-loader__line--loaded');
    }, lineInterval * i);
  });

  // 4. Reveal result at end of duration
  setTimeout(() => {
    const pending = row.querySelector('.kpi-result__icon--pending');
    const check   = row.querySelector('.kpi-result__icon--check');
    const error   = row.querySelector('.kpi-result__icon--error');

    pending.style.display = 'none';

    if (isSuccess) {
      check.style.display = 'block';
    } else {
      error.style.display = 'block';
    }

    // 5. After a pause, restart the cycle
    const restartDelay = randomInt(2_000, 4_000);
    setTimeout(() => runRow(row), restartDelay);

  }, duration);
}
